export var CONVERSATION_REPOSITORY = 'CONVERSATION_REPOSITORY';